module.exports = __webpack_public_path__ + "img/m2-5x8lluomudaozhu.prt.023d3c5c.jpg";